import { createSlice } from "@reduxjs/toolkit";
import { linkExpiredAPI } from "../../api/auth";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const linkExpiredSlice = createSlice({
  name: "linkExpired",
  initialState: data,
  reducers: {
   linkExpiredSlice(state) {
      state.isLoading = true;
    },
   linkExpiredSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    linkExpiredSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   linkExpiredSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const linkExpiredHandler = (data:any) => async (dispatch: any) => {
  try {
    dispatch(linkExpiredAction.linkExpiredSlice());
    const response: any = await linkExpiredAPI(data);
    
    dispatch(linkExpiredAction.linkExpiredSliceSuccess(response));
  } catch (e: any) {
    dispatch(linkExpiredAction.linkExpiredSliceFailure(e?.response?.data));
  }
};
export default linkExpiredSlice.reducer;
export const linkExpiredAction = linkExpiredSlice.actions;
